// Trzy edity sceny strony głównej (artboardy 01, 01b, 01c).
//
// Kompozycja jest decyzją właściciela i zostaje: środkowy kadr 264 × 469 wyżej,
// boczne 220 × 391 pochylone o 4 stopnie. Oprawa w stylu TikToka (avatar z plusem,
// serce, dymek, strzałka, krążek, podpis konta i utworu) jest MARTWĄ DEKORACJĄ:
// `aria-hidden`, zero celów dotyku, zero akcji. Strzałki nie wolno podpiąć pod żadną
// funkcję — inwariant 8 (EDIMI nie udostępnia treści użytkownika nikomu poza
// właścicielem) i klasyfikacja DSA stoją i upadają na tym, że tu nie ma udostępniania.
// ZERO LICZB przy oprawie: polubienia i odtworzenia to słownik zakazany.
//
// Klikalny jest wyłącznie cały kadr; otwiera okno odtwarzacza 01b (wideo 405 × 720
// na zasłonie sceny). Gdy plik przykładu się nie wczyta, okno ZOSTAJE otwarte i pokazuje
// wzorzec błędu z 07d: zdanie, droga naprawy i kod operacji (01c).

import { useState } from 'react'
import { Dialog } from '../ds/feedback/Dialog'
import { Icon } from '../ds/media/Icon'
import { Media } from '../ds/media/Media'
import { Player } from '../ds/media/Player'
import { usePlayerLabels } from './SeriesMedia'
import { useT } from '../lib/i18n'

// Tylko publiczne materiały przykładowe; oprawa jest dekoracją, nie kanałem. Podpis editu
// i tytuł utworu mówią językiem strony (`landing.showcase.examples.*`, PROD2 F2-16: `/en`
// pokazywało polskie); nazwa konta jest nazwą własną i zostaje tutaj.
const EXAMPLES = [
  { id: 'night-preview-1', pos: 'mp-ed-l', poster: 'nostalgia-02-przystanek-we-mgle-t01', at: 'left', handle: '@nocna.zmiana' },
  { id: 'night-preview-2', pos: 'mp-ed-c', poster: 'nostalgia-03-latarnia-i-deszcz-t01', at: 'center', handle: '@nocna.jazda' },
  { id: 'night-preview-3', pos: 'mp-ed-r', poster: 'nostalgia-05-przejscie-wsrod-zieleni-t01', at: 'right', handle: '@zostan.chwile' },
] as const

/** Kod operacji, jak przy każdym innym błędzie operacji (MAPA: `showcase-`). */
const SHOWCASE_ERROR_CODE = 'showcase-404'

export default function LandingEditShowcase() {
  const t = useT()
  const labels = usePlayerLabels()
  const [active, setActive] = useState<number | null>(null)
  const [failed, setFailed] = useState(false)
  // Ponowna próba: nowy klucz odtwarzacza, żeby <video> naprawdę wczytało plik jeszcze raz.
  const [attempt, setAttempt] = useState(0)
  const sample = active === null ? null : EXAMPLES[active]

  return <>
    <div className="mp-fan">
      {EXAMPLES.map((item, index) => (
        <button key={item.id} type="button" className={`mp-ed ${item.pos}`}
                aria-label={t('landing.showcase.playExample', { n: index + 1 })}
                onClick={() => { setFailed(false); setAttempt(0); setActive(index) }}>
          <img className="mp-ed-poster" src={`/kadry/${item.poster}.jpg`} alt="" width="360" height="640" />
          <span className="mp-ed-shade" aria-hidden="true" />
          <span className="mp-ed-lyric" aria-hidden="true">{t(`landing.showcase.examples.${item.at}.lyric`)}</span>
          <span className="mp-ed-play" aria-hidden="true"><Icon name="Play" size={20} /></span>
          <span className="mp-soc" aria-hidden="true">
            <span className="mp-av">
              <img src={`/kadry/${item.poster}.jpg`} alt="" width="36" height="36" />
              <b><Icon name="Plus" size={10} strokeWidth={3} /></b>
            </span>
            <Icon name="Heart" size={26} />
            <Icon name="MessageCircle" size={26} />
            <Icon name="Forward" size={26} />
            <span className="mp-disc"><img src={`/kadry/${item.poster}.jpg`} alt="" width="18" height="18" /></span>
          </span>
          <span className="mp-cap" aria-hidden="true">
            <b>{item.handle}</b>
            <span><Icon name="Music2" size={12} />{t(`landing.showcase.examples.${item.at}.track`)}</span>
          </span>
        </button>
      ))}
    </div>

    {sample && (
      <Dialog title={t('landing.showcase.playExample', { n: active! + 1 })}
              onClose={() => setActive(null)} className="mp-preview">
        {failed ? (
          <div className="mp-preview-player player is-failed">
            <Media ratio="9:16" src={`/kadry/${sample.poster}.jpg`} alt="" className="player-stage">
              <div className="mp-preview-error" role="alert">
                <span>{t('landing.showcase.error')}</span>
                <button type="button" className="mn-lnk" onClick={() => { setFailed(false); setAttempt((n) => n + 1) }}>
                  <Icon name="RefreshCw" size={16} />{t('landing.showcase.retry')}
                </button>
                <span className="mp-code">{SHOWCASE_ERROR_CODE}</span>
              </div>
            </Media>
          </div>
        ) : (
          <Player key={attempt} src={`/showcase/${sample.id}.mp4`} poster={`/kadry/${sample.poster}.jpg`}
                  labels={labels} autoPlay durationHint={8} onError={() => setFailed(true)}
                  className="mp-preview-player">
            <span className="mp-preview-lyric" aria-hidden="true">{t(`landing.showcase.examples.${sample.at}.lyric`)}</span>
          </Player>
        )}
      </Dialog>
    )}
  </>
}
